export default "__VITE_ASSET__t6UxH3Sj__"